import { useCallback } from 'react'
import {
  useStartRecordMutation,
  useEndRecordMutation,
  useJoinMeetingFromWaitingMutation,
} from '@crew/apis/meeting/meetingApis'
import { useAppDispatch } from 'states/hooks'
import { setJoinState } from 'features/webMeeting/states/webMeetingSlice'
import { MeetingAttendeeJoinState } from '@crew/enums/domain'

export const useEventDetailWebMeetingPanel = () => {
  const dispatch = useAppDispatch()

  // Get function for start/end record meeting
  const [startRecordMutation, { isLoading: isLoadingStartRecordMutation }] =
    useStartRecordMutation()
  const [endRecordMutation, { isLoading: isLoadingEndRecordMutation }] =
    useEndRecordMutation()
  const [joinMeetingFromWaitingMutation] = useJoinMeetingFromWaitingMutation()

  // Start record meeting
  const startRecord = useCallback(
    async (meetingId: string) => {
      const result = await startRecordMutation({ meetingId }).unwrap()
      return result
    },
    [startRecordMutation]
  )

  // End record meeting
  const endRecord = useCallback(
    async (meetingId: string) => {
      await endRecordMutation({
        meetingId,
      }).unwrap()
    },
    [endRecordMutation]
  )

  // Join meeting from waiting list
  const joinMeetingFromWaiting = useCallback(
    async (meetingId: string, attendeeId: string) => {
      await joinMeetingFromWaitingMutation({
        meetingId,
        attendeeId,
      }).unwrap()

      dispatch(setJoinState(MeetingAttendeeJoinState.Joining))
    },
    [dispatch, joinMeetingFromWaitingMutation]
  )

  return {
    startRecord,
    endRecord,
    joinMeetingFromWaiting,
    isLoadingStartRecordMutation,
    isLoadingEndRecordMutation,
  }
}
